import React, { useEffect } from "react"
import Header from "../components/Header"
import PinkSection from "../components/elements/RedSection"

const Confirm: React.FC = () => {
	function track(label: string) {
		try {
			// eslint-disable-next-line
			let dataLayer = window["dataLayer"] || []
			dataLayer.push({ event: "footer", link: label })
		} catch (e) {}
	}

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			<Header page="promosoon"  />
				<div className=" mx-auto px-6 pb-12 text-center lg:max-w-[850px] lg:pb-24 lg:pt-6 lg:pr-6 -mt-[600px] lg:-mt-[40%]">
					{" "}
					<h2 className="pb-4 pt-12 text-[22px] font-bold uppercase leading-[24px] text-yellow lg:mb-8 lg:text-[52px] lg:leading-[58px]">
						VIELEN DANK FÜR DEIN INTERESSE AN UNSEREM GEWINNSPIEL.
					</h2>
					<p className="mb-4 text-[16px] text-yellow lg:text-[24px]">
						Leider ist der Teilnahmezeitraum erst ab dem 01.06.2026 möglich.
						Besuche uns so lange auf {" "}
						<a href="https://www.hawaiian-tropic.de" className="underline" target="_blank">
							www.hawaiian-tropic.de
						</a>
						, auf{" "}
						<a href="https://www.instagram.com/hawaiiantropic_eu/" className="underline" target="_blank">
							Instagram
						</a>{" "}
						oder{" "}
						<a href="https://www.tiktok.com/@hawaiiantropic" className="underline" target="_blank">
							Tik Tok
						</a>{" "}
						und bleib auf dem Laufenden.
					</p>
				</div>
		</>
	)
}
export default Confirm
